import React from "react";

import { faCircleExclamation } from "@fortawesome/pro-regular-svg-icons";
import { faCircleXmark, faTriangleExclamation } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { useAskPerformYardStore } from "../AskPerformYardStore";

type ChatErrorBannerProps = {
	type: "no-documents" | "error";
	message?: string;
};

export const ChatErrorBanner: React.FC<ChatErrorBannerProps> = ({ type, message }) => {
	const setError = useAskPerformYardStore((state) => state.setError);

	if (type === "no-documents") {
		return (
			<div
				className="flex flex-1 flex-col items-center justify-center px-4 py-4"
				data-testid="error-banner-no-documents"
			>
				<div className="flex flex-col items-center gap-2">
					<div className="flex h-10 w-10 items-center justify-center rounded-full bg-[#FDE9E6]">
						<FontAwesomeIcon icon={faCircleExclamation} className="h-6 w-6 text-[#F1634F]" />
					</div>
					<p className="text-center text-base leading-6 font-semibold text-[#2F3237]">
						Ask PerformYard needs access to documents to provide answers. Please upload or enable documents
						in Company Resources, or contact your administrator to get started.
					</p>
				</div>
			</div>
		);
	}

	return (
		<div className="flex w-[95.5%] animate-in items-center gap-2 rounded bg-[#FDE9E6] p-2 duration-200 fade-in slide-in-from-bottom-2">
			<FontAwesomeIcon icon={faTriangleExclamation} className="h-4 w-4 shrink-0 text-[#F1634F]" />

			<div className="flex min-w-0 flex-1 flex-col text-xs leading-4 text-[#2F3237]">
				<span className="font-semibold">Something went wrong.</span>
				<span>{message || "Please try again."}</span>
			</div>

			<button
				type="button"
				onClick={() => setError(null)}
				className="shrink-0 cursor-pointer border-none bg-transparent p-0"
				aria-label="Dismiss error"
			>
				<FontAwesomeIcon icon={faCircleXmark} className="h-4 w-4 text-[#F1634F]" />
			</button>
		</div>
	);
};

export default ChatErrorBanner;
